import {FieldsForm} from '../fields/types'
import {OrderScope} from '../types'

import {OrderIntakeType} from './types'

// TODO: improve this function when all props are known
export const buildOrderIntakeAnalyticsData = (
  orderIntakeType: OrderIntakeType,
  form: FieldsForm,
  scope: OrderScope
) => ({
  ...(orderIntakeType === 'copy' && {
    // add to some order intake input params?
    // copiedOrderId: caseProps.oldOrder ?? caseProps.oldOrder.copiedFromOrderId,
    // requestId: caseProps.oldOrder.orderRequestId,
    oldOrderQuantity:
      form.quantity.type === 'volume' ? form.quantity.volume : form.quantity.fullLoads
    // add when form would be extended with those props
    // oldMix: caseProps.oldOrder.mix,
    // oldUnloadingMethod: caseProps.oldOrder.unloadingMethodCode,
    // oldOrderDate: caseProps.oldOrder.orderDateTime,
  }),
  orderIntakeType: orderIntakeType,
  orgUnitId: scope.orgUnitId,
  siteId: scope.shippingAddress.siteId,
  customerId: scope.customer.customerId
})

export type OrderIntakeAnalyticsData = ReturnType<typeof buildOrderIntakeAnalyticsData>
